import { attach, createEffect, createEvent, createStore } from 'effector'
import type { Location } from 'history'
import { type NavigateFunction } from 'react-router-dom'

import { noop } from '@/utils/misc'
import { getQueryString } from '@/utils/routes.ts'

export const changeNavigate = createEvent<NavigateFunction>(
  'change navigate function',
)
export const $navigate = createStore<NavigateFunction>(noop, {
  name: 'navigate function',
}).on(changeNavigate, (store, navigate) => (store === noop ? navigate : store))

export interface QueryParams {
  readonly addCreator?: Nullable<number>
}

export const navigateToFx = attach({
  name: 'navigate to',
  source: $navigate,
  mapParams: (
    { path, params }: { path: Nullable<string>; params?: Partial<QueryParams> },
    navigate,
  ) => ({
    path: path ? (params ? `${path}${getQueryString(params)}` : path) : null,
    navigate,
  }),
  effect: createEffect(
    ({
      navigate,
      path,
    }: {
      navigate: NavigateFunction
      path: Nullable<string>
    }) => {
      if (path) {
        navigate(path)
      }
    },
  ),
})

export const redirectToFx = createEffect({
  name: 'redirect to',
  handler: (path: string) => {
    // console.log(`>> redirect to: ${path}`)
    window.location.href = path
  },
})

export const openFx = createEffect({
  name: 'open new page',
  handler: (path: string) => {
    window.open(path, '_blank', 'noopener,noreferrer')?.focus()
  },
})

export const changeLocation = createEvent<Location>('change location')

// @ts-ignore
export const $location = createStore<Location>(window.location, {
  name: 'location',
}).on(changeLocation, (_, location) => location)

export const $URLSearchParams = $location.map(({ search }) => {
  return new URLSearchParams(search)
})

export const $queryParams = $URLSearchParams.map(
  (searchParams): QueryParams => {
    return {
      addCreator: searchParams.get('addCreator')
        ? parseInt(searchParams.get('addCreator')!, 10)
        : null,
    }
  },
)

export const $currentPage = $location.map(({ pathname }) => pathname)
